export default __webpack_public_path__ + "static/media/EastSettlementofDinog.0452bba9.jpg";